import React from 'react';
import './ServicesSection.css';
import { Link } from 'react-router-dom';

function ServicesSection() {

  return (

    <section className="services-section">

      <div className="services-container">

        <div className="services-header">

          <p>OUR SERVICES</p>

          <h2>Professional Cleaning Solutions</h2>

          <span>
            Mobile car wash, home cleaning,
            and Airbnb reset services across Cape Town.
          </span>

        </div>

        <div className="services-grid">

          {/* CAR DETAILING */}

          <Link to="/services" className="service-card">

            <img
              src="https://images.unsplash.com/photo-1607860108855-64acf2078ed9?q=80&w=1974&auto=format&fit=crop"
              alt="Car Detailing"
            />

            <div className="service-overlay">

              <h3>Car Detailing</h3>

              <p>
                Exterior wash, vacuuming,
                polishing & detailing.
              </p>

            </div>

          </Link>

          {/* HOUSE CLEANING */}

          <Link to="/services" className="service-card">

            <img
              src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=1974&auto=format&fit=crop"
              alt="House Cleaning"
            />

            <div className="service-overlay">

              <h3>House Cleaning</h3>

              <p>
                Kitchens, bathrooms,
                floors, dusting & sanitizing.
              </p>

            </div>

          </Link>

          {/* AIRBNB RESET */}

          <Link to="/services" className="service-card">

            <img
              src="/lady-cleaning.png"
              alt="Airbnb Cleaning"
            />

            <div className="service-overlay">

              <h3>Airbnb Cleaning / Reset</h3>

              <p>
                Guest turnover cleaning,
                vacuuming & bed reset.
              </p>

            </div>

          </Link>

        </div>

      </div>

    </section>

  );
}

export default ServicesSection;

